// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stoplight-content {
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;
   height: 100%;
   overflow: auto;
}

.stoplight-content label {
   width: 100%;
   text-overflow: ellipsis;
   overflow: hidden;
   white-space: nowrap;
}

.stoplight-container .stop-light {
   background-color: var(--alto-gray);
   display: flex;
   justify-content: space-around;
   align-items: center;
   border-radius: var(--border-radius);
}

.stoplight-container .stop-light.horizontal {
   width: 100%;
   height: 100%;
}

.stoplight-container .stop-light.vertical {
   flex-direction: column;
   width: 100%;
   height: 100%;
}

.stoplight-container .circle {
   border-radius: 100%;
   background-color: var(--dust-gray);
}

.stoplight-container .stop-light.vertical .circle {
   width: 80%;
   height: 40%;
}

.stoplight-container .stop-light.horizontal .circle {
   height: 80%;
   width: 40%;
}

.stoplight-container .stop-light .green-circle {
   background-color: var(--jade-glow);
}

.stoplight-container .stop-light .red-circle {
   background-color: var(--red-fire);
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLDataViz/ECLStopLight/ECLStopLight.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,sBAAsB;GACtB,mBAAmB;GACnB,WAAW;GACX,YAAY;GACZ,cAAc;AACjB;;AAEA;GACG,WAAW;GACX,uBAAuB;GACvB,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,kCAAkC;GAClC,aAAa;GACb,6BAA6B;GAC7B,mBAAmB;GACnB,mCAAmC;AACtC;;AAEA;GACG,WAAW;GACX,YAAY;AACf;;AAEA;GACG,sBAAsB;GACtB,WAAW;GACX,YAAY;AACf;;AAEA;GACG,mBAAmB;GACnB,kCAAkC;AACrC;;AAEA;GACG,UAAU;GACV,WAAW;AACd;;AAEA;GACG,WAAW;GACX,UAAU;AACb;;AAEA;GACG,kCAAkC;AACrC;;AAEA;GACG,iCAAiC;AACpC","sourcesContent":[".stoplight-content {\r\n   display: flex;\r\n   flex-direction: column;\r\n   align-items: center;\r\n   width: 100%;\r\n   height: 100%;\r\n   overflow: auto;\r\n}\r\n\r\n.stoplight-content label {\r\n   width: 100%;\r\n   text-overflow: ellipsis;\r\n   overflow: hidden;\r\n   white-space: nowrap;\r\n}\r\n\r\n.stoplight-container .stop-light {\r\n   background-color: var(--alto-gray);\r\n   display: flex;\r\n   justify-content: space-around;\r\n   align-items: center;\r\n   border-radius: var(--border-radius);\r\n}\r\n\r\n.stoplight-container .stop-light.horizontal {\r\n   width: 100%;\r\n   height: 100%;\r\n}\r\n\r\n.stoplight-container .stop-light.vertical {\r\n   flex-direction: column;\r\n   width: 100%;\r\n   height: 100%;\r\n}\r\n\r\n.stoplight-container .circle {\r\n   border-radius: 100%;\r\n   background-color: var(--dust-gray);\r\n}\r\n\r\n.stoplight-container .stop-light.vertical .circle {\r\n   width: 80%;\r\n   height: 40%;\r\n}\r\n\r\n.stoplight-container .stop-light.horizontal .circle {\r\n   height: 80%;\r\n   width: 40%;\r\n}\r\n\r\n.stoplight-container .stop-light .green-circle {\r\n   background-color: var(--jade-glow);\r\n}\r\n\r\n.stoplight-container .stop-light .red-circle {\r\n   background-color: var(--red-fire);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
